<template>
  <header>
    <UiToastList />

    <div class="bck-btns">
      <!-- Back button -->
      <a href="#" @click.prevent="handleBack">
        <i class="fa-solid fa-arrow-left"></i> Go Back
      </a>

      <img v-if="showLogo" :src="logoPath" alt="Logo" :class="['h-logo', { 'adv-eye-logo': isAdvEye }]" />
      <div class="d-flex align-items-center" style="position: relative;">
        <router-link to="/hospital-global-settings" class="gear-icon">
          <i class="fa-solid fa-gear"></i> Setup
        </router-link>
        <router-link to="/appointments">
          <i class="fa-solid fa-arrow-right-to-bracket"></i> Exit
        </router-link>
      </div>
    </div>

    <!-- Floating Setup button — mobile/tablet only -->
    <router-link to="/hospital-global-settings" class="fab-setup">
      <i class="fa-solid fa-gear"></i>
    </router-link>
  </header>
</template>

<script>
import UiToastList from "@/components/UiToastList";
import dshLogo from "@/assets/img/dsh-logo.png";
import mamabotsLogo from "@/assets/img/mamabots-logo-edit.png";
import advEyeLogo from "@/assets/img/adv-eye-logo-1.png";
import { isAdvancedEyeDomain } from "@/utils/helpers";

export default {
  name: "HeaderView",
  components: { UiToastList },
  props: {
    backRoute: {
      type: String,
      default: null, // Optional now
    },
    showLogo: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    logoPath() {
      const hospitalId = localStorage.getItem("hospitalId") || "default";
      console.log("logoPath: ", hospitalId)
      const logoMap = {
        "1234567890abcdef12345678": mamabotsLogo,
        "68d68a07d3f9b7819cd05e80": advEyeLogo,
        "69f0d15795726d56441d9718": mamabotsLogo,
        "68306098776144597cc2a7d8": dshLogo,
        default: mamabotsLogo,
      };

      console.log("sdjflkdjsf", isAdvancedEyeDomain() , advEyeLogo,  logoMap[hospitalId] , logoMap.default)
      return isAdvancedEyeDomain() ? advEyeLogo : logoMap[hospitalId] || logoMap.default;
    },
    isAdvEye() {
      return this.logoPath === advEyeLogo;
    }
  },
  methods: {
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("ID");
      this.$router.push("/login");
    },

    handleBack() {
      // Priority:
      // 1. If backRoute prop exists, use it
      if (this.backRoute) {
        this.$router.push(this.backRoute);
      }
      // 2. If history.state.from exists, use it
      else if (history.state && history.state.from) {
        this.$router.push(history.state.from);
      }
      // 3. Otherwise, fallback to history.back()
      else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style scoped>
.h-logo {
  width: 200px;
}

.gear-icon {
  position: absolute;
  top: 0px;
  left: -170px;
}

/* Hide header Setup link on tablet/mobile */
@media (max-width: 1024px) {
  .gear-icon {
    display: none;
  }
}

/* Floating Setup FAB — tablet/mobile only */
.fab-setup {
  display: none;
  position: fixed;
  bottom: 80px;
  right: 24px;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background-color: #3c78f9;
  color: #fff;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  box-shadow: 0 4px 14px rgba(60, 120, 249, 0.4);
  z-index: 999;
  text-decoration: none;
  transition: transform 0.2s, box-shadow 0.2s;
}

.fab-setup:hover {
  transform: scale(1.08);
  box-shadow: 0 6px 18px rgba(60, 120, 249, 0.5);
}

@media (max-width: 1024px) {
  .fab-setup {
    display: flex;
  }
}

.h-logo {
  width: 200px;
}

.adv-eye-logo {
  width: 280px;
  /* bigger width */
  height: auto;
  /* keep aspect ratio */
}


/* Basic styles for header
header {
  background-color: #333;
  padding: 10px 0;
}
nav ul {
  display: flex;
  justify-content: center;
  list-style: none;
}
nav li {
  margin: 0 15px;
}
nav a {
  color: white;
  text-decoration: none;
  font-size: 18px;
}
nav a:hover {
  text-decoration: underline;
} */
</style>
